import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=4e66740b&scoped=true"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"
import style0 from "./staff.vue?vue&type=style&index=0&id=4e66740b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66740b",
  null
  
)

export default component.exports